// <Alert> — the ONLY way to surface notices. GITEX RULE #2 bans system dialogs
// (window.alert/confirm). Text comes from the i18n catalog via the caller.
import type { ReactNode } from 'react';
import { useLanguage } from '../context/LanguageContext';
import styles from './Alert.module.css';

export type AlertVariant = 'info' | 'success' | 'danger' | 'warning';

interface AlertProps {
  readonly variant?: AlertVariant;
  readonly children: ReactNode;
  readonly onDismiss?: () => void;
}

export function Alert({ variant = 'info', children, onDismiss }: AlertProps): JSX.Element {
  const { t } = useLanguage();
  return (
    <div className={`${styles.alert} ${styles[variant]}`} role="alert">
      <span>{children}</span>
      {onDismiss !== undefined && (
        <button type="button" className={styles.dismiss} onClick={onDismiss}>
          {t('alert.dismiss')}
        </button>
      )}
    </div>
  );
}
